import { ToolPageShell } from '@/shared/seo'
import { JpgVPdfForm } from './JpgVPdfForm'

export function JpgVPdfPage() {
  return (
    <ToolPageShell utilityKey="jpgVPdf">
      <JpgVPdfForm />
    </ToolPageShell>
  )
}
